<template>
  <div>
    <div style="height: 100%">
              <div class="example-wrapper">
                  <div class="example-header">
                    <h4>Videos<button style="margin-right: 100px; background-color: green; color: white;"
                            v-on:click="onBtnExport()">Export CSV</button></h4>
                  </div>
                  <ag-grid-vue
                    style="width: 100%; height: 900px;"
                    class="ag-theme-alpine"
                    :columnDefs="columnDefs"
                    @grid-ready="onGridReady"
                    :defaultColDef="defaultColDef"
                    :rowSelection="rowSelection"
                    :rowData="rowData"
                    @selection-changed="onSelectionChanged">
                  </ag-grid-vue>
              </div>
      </div>
  </div>
  </template>
  
<script>
  import api from '../api.js';
  import { AgGridVue } from "ag-grid-vue";
  export default {
    name: 'App',
    components: {
    'ag-grid-vue': AgGridVue,
    },
    data: function() {
      return {
        columnDefs: [
          { field: 'id', filter: 'agNumberColumnFilter' },
          { field: 'tenant_id', filter: 'agNumberColumnFilter' },
          { field: 'video_url'},
          { field: 'youtube_embed_id', filter: 'agNumberColumnFilter' },
          { field: 'duration', filter: 'agNumberColumnFilter' },
          { field: 'start_time', filter: 'agNumberColumnFilter' },
          { field: 'end_time', filter: 'agNumberColumnFilter' },
          { field: 'is_public' },
          { field: 'is_active' },
          { field: 'video_status' }
        ],
        gridApi: null,
        columnApi: null,
        defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 100,
        flex: 1,
        },
        rowData: null
      };
    },
    methods: {
    onSelectionChanged() {
        var selectedRows = this.gridApi.getSelectedRows();
        var selectedRowsString = '';
        var maxToShow = 5;
        selectedRows.forEach(function (selectedRow, index) {
          if (index >= maxToShow) {
            return;
          }
          if (index > 0) {
            selectedRowsString += ', ';
          }
          selectedRowsString += selectedRow.video_id;
        });
        if (selectedRows.length > maxToShow) {
          var othersCount = selectedRows.length - maxToShow;
          selectedRowsString +=
            ' and ' + othersCount + ' other' + (othersCount !== 1 ? 's' : '');
        }
        document.querySelector('#selectedRows').innerHTML = selectedRowsString;
      },
      onBtnExport() {
        this.gridApi.exportDataAsCsv();
      },
      async onGridReady(params, tenant_id) {
        if(params != undefined) {
          this.gridApi = params.api;
          this.gridColumnApi = params.columnApi;
        }
        const updateData = (data) => {
          this.rowData = data;
        };
        let testingData = '';
        if (tenant_id != undefined) {
            try {
              testingData = await api.getLatestVideos(tenant_id);
            } catch(error) {
              this.$bvToast.toast("Error while retrieving videos data.", {
                variant: "danger",
              });
            }
        }
        updateData(testingData);
        },
    },
    created() {
      this.rowSelection = 'multiple';
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === "setSelectedTenant") {
            this.onGridReady(this.params, mutation.payload);
        }
      })
    },
  };

</script>
  
<style>
  @import "~ag-grid-community/styles/ag-grid.css";
  @import "~ag-grid-community/styles/ag-theme-alpine.css";
</style>
  